import { configureStore } from '@reduxjs/toolkit'
import authReducer from './slices/authSlice'
import campaignReducer from './slices/campaignSlice'
import emailAccountReducer from './slices/emailAccountSlice'
import uiReducer from './slices/uiSlice'

export const store = configureStore({
  reducer: {
    auth: authReducer,
    campaigns: campaignReducer,
    emailAccounts: emailAccountReducer,
    ui: uiReducer,
  },
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch 